import { render, staticRenderFns } from "./word-view.vue?vue&type=template&id=3a27b85d&scoped=true&"
import script from "./word-view.vue?vue&type=script&lang=js&"
export * from "./word-view.vue?vue&type=script&lang=js&"
import style0 from "./word-view.vue?vue&type=style&index=0&id=3a27b85d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a27b85d",
  null
  
)

export default component.exports